const EVENT = 'bs:soft-success';

/** Show a short success toast anywhere in the app. */
export function showSoftSuccess(message = 'Сохранено') {
  if (typeof window === 'undefined') return;
  const text = String(message || 'Сохранено').trim() || 'Сохранено';
  window.dispatchEvent(new CustomEvent(EVENT, { detail: { message: text } }));
}

export function subscribeSoftSuccess(handler) {
  if (typeof window === 'undefined') return () => {};
  const listener = (event) => {
    handler(event?.detail?.message || 'Сохранено');
  };
  window.addEventListener(EVENT, listener);
  return () => window.removeEventListener(EVENT, listener);
}
